import React, { useCallback, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';

import { searchParams } from '../../data/store/portfolio/portfolioActions';
import { AutoComplete, Form, Tooltip } from 'antd';
import { EditableContext } from './Portfolio';
import { formatDate } from '../../helpers/formatDate';
import CustomInputNumber from '../CustomInputNumber/CustomInputNumber';

const EditableCellNew = ({
  editing,
  children,
  dataIndex,
  record,
  handleSave,
  data,
  setTarget,
  decimalSeparator,
  ...restProps
}) => {
  const dispatch = useDispatch();
  const form = useContext(EditableContext);
  const { instruments } = useSelector((state) => state.portfolioReducer);

  useEffect(() => {
    if (dataIndex) {
      form.setFieldsValue({
        [dataIndex]: record[dataIndex],
      });
    }
  }, [dataIndex, record]);

  const save = async (value, obj) => {
    
    const instrumentsObj = instruments?.list?.find((instrument) => {
      return instrument.ID === obj?.key || instrument.ID === record?.key || instrument.name === value?.target?.value;
    });
    try {
      const values = await form.validateFields();
      if (dataIndex === 'units_number') {
        const newData = {
          ...record,
          ...values,
          instrument_name: record?.instrument_name ?? '',
          value:
            values?.units_number *
            (values?.latest_value_sek || record?.latest_value_sek),
          units_number: Math.trunc(values.units_number * 10000) / 10000,
        };
        handleSave(newData);
      }  else if (dataIndex === 'latest_value') {
        const newData = {
          ...record,
          ...values,
          latest_value_sek: !record?.financial_asset_id ? values?.latest_value : record?.latest_value_sek,
          currency_id: 1,
          value:
            values?.units_number *
            (values?.latest_value || record?.latest_value),
        };
        handleSave(newData);
      } else {

        instrumentsObj
          ? handleSave({
            ...record,
            ...values,
            instrument_name: instrumentsObj.name,
            currency_id: instrumentsObj.currency_id,
            latest_value:
                Math.round(instrumentsObj.latest_value * 100) / 100,
            latest_value_sek:
              Math.round(instrumentsObj.latest_value_sek * 100) / 100,
            isin: instrumentsObj.isin,
            finstrument_name: instrumentsObj.name,
            financial_instrument_id: instrumentsObj.ID,
            fee: instrumentsObj.fee,
            asset_class: instrumentsObj.financialAsset.name,
            financial_asset_id: instrumentsObj.financialAsset.ID,
            financial_asset_category_id:
                instrumentsObj.financialAsset.financialAssetCategoryID,
          })
          : handleSave({
            ...record,
            ...values,
            isin: record?.isin || 'N/A',
            asset_class: record?.asset_class || 'TBD',
            financial_asset_id: record?.financial_asset_id || null,
            financial_asset_category_id: record?.financial_asset_category_id || null,
            financial_instrument_id: record?.financial_instrument_id || null,
          });
      }
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  };

  const renderOptions = useCallback(() => {
    if (Object.keys(instruments).length === 0) {
      return [];
    } else {
      const dataId = data?.map((el) => el.financial_instrument_id);
      const filterInstruments = instruments.list.filter(
        (el) => !dataId?.includes(el.ID) && el?.financialAssetID !== 32,
      );
      const options = filterInstruments?.map((el) => ({
        value: el.name + '_' + el.ID.toString(),
        label: dataIndex === 'isin' 
          ? (el.isin === 'NOT_APPLICABLE' ? 'N/A' : el.isin)
          : el.name,
        key: el.ID,
      }));
      return options?.sort((a, b) =>
        a.label > b.label ? 1 : b.label > a.label ? -1 : 0,
      );
    }
  }, [instruments, data]);

  const onChange = useCallback(
    (value) => {
      dispatch(searchParams(value || ' '));
    },
    [dispatch, data],
  );

  if (
    editing &&
    !(
      dataIndex === 'latest_value' &&
      record.isin &&
      record.isin !== 'N/A'
    ) &&
    !(
      dataIndex === 'latest_value' &&
      record.financialInstrumentName === 'Cash'
    )
  ) {
    return (
      <td {...restProps}>
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
        >
          {['units_number', 'latest_value'].includes(dataIndex)
            ? (
            <CustomInputNumber
              className='custom-inputnumber'
              decimalSeparator={decimalSeparator}
              style={{ width: '100%' }}
              min={0}
              onBlur={save}
              onChange={save}
              onInput={save}
              placeholder={record[dataIndex]}
            />
              )
            : !record?.id
                ? (
              <AutoComplete
                className="custom-select"
                popupClassName='custom-dropmenu-wrapper'
                popupMatchSelectWidth={360}
                style={{ width: '100%' }}
                options={renderOptions()}
                onBlur={save}
                onSelect={save}
                onKeyPress={(v) => v.code === 'Enter' && save()}
                onChange={onChange}
                placeholder={record[dataIndex]}
              />
                  )
                : (
              <td {...restProps} onClick={setTarget}>
                {children}
              </td>
                  )
            }
        </Form.Item>
      </td>
    );
  } else {
    return dataIndex !== 'latest_value'
      ? (
      <td {...restProps} onClick={setTarget}>
        {children}
      </td>
        )
      : (
      <Tooltip
        placement="top"
        title={
          <span style={{ color: '#000000' }}>
            {formatDate(record?.latest_value_time)}
          </span>
        }
        color="white"
      >
        <td {...restProps} onClick={setTarget}>
          {children}
        </td>
      </Tooltip>
        );
  }
};

export default EditableCellNew;

EditableCellNew.propTypes = {
  title: PropTypes.node,
  editing: PropTypes.bool,
  children: PropTypes.node,
  dataIndex: PropTypes.string,
  record: PropTypes.object,
  handleSave: PropTypes.func,
  setTarget: PropTypes.func,
  data: PropTypes.array,
  decimalSeparator: PropTypes.string,
};